import React from "react";

const EmployeePreviewData = ({ data, deptMap, desigMap, restMap, onClose  }) => {
  if (!data) return null;

  /* ================= STATUS COLOR ================= */

  const statusColor =
    data.empStatus === "Working"
      ? "bg-green-100 text-green-700"
      : data.empStatus === "Left"
      ? "bg-red-100 text-red-700"
      : "bg-gray-100 text-gray-700";

  /* ================= DATE FORMAT ================= */

  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);

    if (isNaN(d.getTime())) return "-";

    if (date.startsWith("0001") || date.startsWith("0002")) return "-";

    return d.toLocaleDateString();
  };

  /* ================= IMAGE ================= */

  const imageUrl = data.empImageFileName
    ? `/uploads/${data.empImageFileName}`
    : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8oghbsuzggpkknQSSU-Ch_xep_9v3m6EeBQ&s";

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex justify-center items-center p-2 sm:p-4">
      {/* MODAL */}
      <div className="bg-white w-full max-w-xl max-h-[92vh] rounded-2xl shadow-xl overflow-hidden flex flex-col">

        {/* HEADER */}
        <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
          <h2 className="font-bold text-lg">Employee Details</h2>

          <button
            onClick={onClose}
            className="text-red-500 text-xl font-bold hover:scale-110"
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <div className="p-4 space-y-5 overflow-y-auto">

          {/* IMAGE */}
          <div className="flex justify-center">
            <img
              src={imageUrl}
              onError={(e) => {
                e.target.src =
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8oghbsuzggpkknQSSU-Ch_xep_9v3m6EeBQ&s";
              }}
              alt="Employee"
              className="w-24 h-24 sm:w-28 sm:h-28 rounded-xl object-cover border"
            />
          </div>

          {/* STATUS */}
          <div className="flex justify-center">
            <span
              className={`px-3 py-1 rounded-full text-xs font-semibold ${statusColor}`}
            >
              {data.empStatus || "-"}
            </span>
          </div>

          {/* ================= BASIC ================= */}

          <SectionTitle title="Basic Information" />

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">

            <Field label="Employee ID" value={data.empId} />

            <Field label="Name" value={data.empName} />

            <ClickableField
              label="Mobile"
              value={data.empMobileNo}
              href={data.empMobileNo ? `tel:${data.empMobileNo}` : null}
            />

          <Field
  label="Department"
  value={deptMap?.[data.departmentId] || "-"}
/>

<Field
  label="Designation"
  value={desigMap?.[data.designationId] || "-"}
/>

<Field
  label="Restaurant"
  value={restMap?.[data.restId] || "-"}
/>

            <Field label="Employee Type" value={data.empType} />

            <Field
              label="Joining Date"
              value={formatDate(data.joiningDate)}
            />

          </div>

          {/* ================= OPTIONAL ================= */}

          <SectionTitle title="Optional Information" />

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">

            <Field label="Aadhar No" value={data.aadharCardNo} />

            <Field label="PAN No" value={data.panNo} />

            <Field label="Birth Date" value={formatDate(data.birthDate)} />

            <Field
              label="Anniversary Date"
              value={formatDate(data.anniversaryDate)}
            />

            <Field
              label="Police Verification No"
              value={data.policeVerificationNo}
            />

            <Field
              label="Police Verification Date"
              value={formatDate(data.policeVerificationDate)}
            />

            <Field label="Reference By" value={data.referenceBy} />

            <ClickableField
              label="Reference Mobile"
              value={data.referenceMobileNo}
              href={
                data.referenceMobileNo
                  ? `tel:${data.referenceMobileNo}`
                  : null
              }
            />

            <Field
              label="Relieving Date"
              value={formatDate(data.relievingDate)}
            />

          </div>

          <div className="h-2" />

        </div>
      </div>
    </div>
  );
};

/* ================= SECTION TITLE ================= */

const SectionTitle = ({ title }) => (
  <div className="text-sm font-semibold text-slate-600 border-b pb-1">
    {title}
  </div>
);

/* ================= NORMAL FIELD ================= */

const Field = ({ label, value }) => (
  <div className="min-w-0">
    <div className="text-slate-500 text-xs sm:text-sm">{label}</div>
    <div className="font-medium break-words">{value || "-"}</div>
  </div>
);

/* ================= CLICKABLE FIELD ================= */

const ClickableField = ({ label, value, href }) => (
  <div className="min-w-0">
    <div className="text-slate-500 text-xs sm:text-sm">{label}</div>

    {value && href ? (
      <a
        href={href}
        className="font-medium text-blue-600 hover:underline break-all"
      >
        {value}
      </a>
    ) : (
      <div className="font-medium">-</div>
    )}
  </div>
);

export default EmployeePreviewData;